import { actionTypes } from '@/store/types';
import store from '@/store';

export default [
  {
    path: '/',
    component: () => import('@/components/layouts/MapView'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/components/panel/DealerList'),
      },
      {
        path: 'company/:companyId',
        name: 'SingleDealer',
        component: () => import('@/components/panel/SingleDealer'),
      },
    ],
  },
  {
    path: '/auth',
    meta: {
      requiresAuth: false,
    },
    beforeEnter(to, from, next) {
      if (!to.query.token) {
        next(false);
        return;
      }

      store.dispatch(actionTypes.sessionNS.setToken, to.query.token);
      next({ name: 'Home' });
    },
  },
  {
    path: '/login/:error?',
    name: 'Login',
    component: () => import('@/components/views/Login'),
    meta: {
      requiresAuth: false,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js